import InnerComponent from '@Components/BulkUpload';
import orgContainer from '@Components/AppContainer';

const BulkUpload = () => ((orgContainer(InnerComponent)));
export default BulkUpload;
